export default __webpack_public_path__ + "static/media/slide4.7826d9f6.jpg";